import React from 'react';
import { faFacebook, faGithub, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Footer.scss'


const Footer = () => {
    const today = new Date();
    const year = today.getFullYear();
    return (
        <footer>
            <div className='container text-center'>
                <div className='row'>
                    <div className='col-12'>
                        <h1 className='fw-lighter mt-5'>Follow</h1>
                        <div className='d-flex justify-content-center gap-4 mt-3 mb-5 gupu'>

                            <a target="_blank" rel='noreferrer' href='https://www.facebook.com/share/1ELLLmh2mN/?mibextid=qi2Omg'>
                                <FontAwesomeIcon icon={faFacebook} color="#ffe100" />
                            </a>
                            <a target="_blank" rel='noreferrer' href='https://www.linkedin.com/in/arefin-khan-441259241/'>
                                <FontAwesomeIcon icon={faLinkedin} color="#ffe100" />
                            </a>
                            <a target="_blank" rel='noreferrer' href='https://github.com/TEMPLAR-007'>
                                <FontAwesomeIcon icon={faGithub} color="#ffe100" />
                            </a>
                            <a target="_blank" rel='noreferrer' href='https://wa.me/8801537249869'>
                                <FontAwesomeIcon icon={faWhatsapp} color="#ffe100" />
                            </a>
                        </div>
                        <hr />
                        <p className='text-warning'><small>copyright @ {year} </small></p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;